import { useCallback, useContext, useEffect, useMemo, useState } from 'react';

import {
  GenericDataFormContext,
  QUOTATION_BUTTON,
  QuotationInfoContext,
  QuotationStep,
  QuotationStepButtons,
} from '../../../../../shared';
import { CarPaymentMethods } from '../PaymentMethods';
import { CarQuotationFormByTab } from '../CarQuotationFormByTab';
import { CarQuotationSummary } from '../CarQuotationSummary';
import { Form, RowSize } from '../../../../../../../../../shared/components';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

import { displayErrorMessage, scrollToEmitButton } from '../../../../../../../../../shared/utils';

import './index.css';

export const CarQuotation = () => {
  const { setCurrentStep } = useContext(QuotationInfoContext);
  const { isErrorServices } = useContext(GenericDataFormContext);
  const { stepTwoForm, stepThreeForm, coverageSelectedByVehicle } = useContext(
    WizardDataFormContext
  );

  const {
    tabs,
    generateTitleForTabs,
    executeCarReQuotations,
    labelButton,
    setLabelButton,
  } = useContext(StepTwoFormContext);

  const [quotationTabs, setQuotationTabs] = useState<Array<any>>([]);
  const [activeTab, setActiveTab] = useState(quotationTabs[0]?.key);

  const setLabelHeader = useCallback(
    (key: number) => {
      if (tabs.length > 1) {
        const brand = stepTwoForm?.getFieldValue(`brand-tab-${key}`);
        const model = stepTwoForm?.getFieldValue(`model-tab-${key}`);
        const year = stepTwoForm?.getFieldValue(`vehicleYear-tab-${key}`);

        return generateTitleForTabs(year, brand, model);
      }

      return `Automóvil ${key}`;
    },
    [stepTwoForm, generateTitleForTabs, tabs]
  );

  const createTabs = useCallback(() => {
    const newTabs = tabs?.map(({ key }: any) => ({
      children: <CarQuotationFormByTab tabKey={key} />,
      forceRender: true,
      closable: false,
      key,
      label: setLabelHeader(key),
    }));

    setQuotationTabs(newTabs);
  }, [tabs, setQuotationTabs, setLabelHeader]);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  const allVehiclesHasSelectedCoverage: boolean = useMemo(
    () => quotationTabs.length === coverageSelectedByVehicle.length,
    [quotationTabs, coverageSelectedByVehicle]
  );

  const handlerOnClickEmit = useCallback(async () => {
    setCurrentStep(QuotationStep.FOUR);
  }, [setCurrentStep]);

   const onPressBackButton = useCallback(async () => {
    setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    setCurrentStep(QuotationStep.TWO);
  }, [setCurrentStep, setLabelButton, stepThreeForm]);

  const handlerOnClick = useCallback(async () => {
    if (!allVehiclesHasSelectedCoverage) {
      return displayErrorMessage(
        'Debe seleccionar una cobertura en todos los vehículos para poder avanzar al paso de emisión'
      );
    }

    if (labelButton === QUOTATION_BUTTON.EMITIR) {
      return handlerOnClickEmit();
    }

    try {      
      await executeCarReQuotations();
    } catch (error: any) {
      if (!isErrorServices) {
        scrollToEmitButton();
        setLabelButton(QUOTATION_BUTTON.EMITIR);
      }else{
        setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
      }
    }
  }, [
    labelButton,
    isErrorServices,
    setLabelButton,
    handlerOnClickEmit,
    executeCarReQuotations,
    allVehiclesHasSelectedCoverage,
  ]);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <>
      <RowSize>
        <Form formProps={{ name: 'car-coverages-form', form: stepThreeForm }}>
          <Tabs
            handlePressTab={handlePressTab}
            activeKey={activeTab}
            items={quotationTabs}
          />
          <CarPaymentMethods />
          <CarQuotationSummary />
        </Form>
      </RowSize>

      <QuotationStepButtons
        label={labelButton}
        onClick={handlerOnClick}
        onPressBackButton={onPressBackButton}
      />
    </>
  );
};
